import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import type { AlternateLocale } from "@/features/blog/locales";
import {
  blogSearchSchema,
  buildBlogListingHead,
  loadBlogListingPage,
} from "@/features/blog/route-data";
import { BlogIndexScreen } from "@/features/blog/screens/BlogIndexScreen";

export const Route = createFileRoute("/_landing/$locale/blog/")({
  validateSearch: zodValidator(blogSearchSchema),
  loaderDeps: ({ search }) => search,
  loader: ({ params, deps }) =>
    loadBlogListingPage(params.locale as AlternateLocale, deps, {
      requirePosts: true,
    }),
  head: ({ loaderData, params }) => {
    return buildBlogListingHead({
      locale: (loaderData?.locale ?? params.locale) as AlternateLocale,
      availableLocales: loaderData?.availableLocales,
    });
  },
  component: LocalizedBlogListingRoute,
});

function LocalizedBlogListingRoute() {
  return <BlogIndexScreen data={Route.useLoaderData()} />;
}
